<template>
  <a-layout class="profile-index">
    <TitleBreadcrumb />

    <router-view name="routerviewprofile"></router-view>
  </a-layout>
</template>
<script>
import TitleBreadcrumb from "@/components/layout/client/TitleBreadcrumb.vue";
import loadingMixin from "@/mixins/loadingMixin";
import labels from "@/utils/labels";

export default {
  components: {
    TitleBreadcrumb,
  },
  name: "Profile",
  mixins: [loadingMixin],
  data() {
    return {
      labels: {
        ...labels.transactionForm,
        appName: labels.appName,
      },
    };
  },
};
</script>

<style lang="scss" scoped>
.profile-index {
  max-width: 100% !important;
  font-family: "Roboto", sans-serif;
  background-color: transparent;
}
</style>
